import AppConstant from '../../config/app.constants';

class BagoutController {
  /*@ngInject*/
  constructor(Auth, $state, User, UserService, RouteService, $translate, BranchService, Modal, ShipmentService, $q, $scope, Sound, SetupService, $rootScope, LocationService, BagoutService, $location, Configs) {

    this.BranchService = BranchService;
    this.$state = $state;
    this.$q = $q;
    this.User = User;
    this.RouteService = RouteService;
    this.ShipmentService = ShipmentService;
    this.SetupService = SetupService;
    this.LocationService = LocationService;
    this.BagoutService = BagoutService;
    this.$translate = $translate;
    this.Modal = Modal;
    this.$scope = $scope;
    this.Sound = Sound;
    this.isError = false;
    this.$rootScope = $rootScope;
    this.user;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();

    this.branches = [];
    this.routes = [];

    this.message = null
    this.messageTwo = null
    this.lastBagoutScanned = null
    this.lastbagScanned = null
    this.isBagScanned = false
    this.prevErrorCode = '';
    this.forceToStope = ['90703', '90704', '90706'];
    this.bagScanDisable = false;
    this.bagoutScanDisable = true;
    this.loading = false;
    this.branchId = null;
    this.bagScanLimit = "";
    this.checkOnlyOnce = false;
    this.totalLocations = 0;
    this.locationList = [];
    this.loadRemainingBagouts = false;
    this.BagoutInfo = '';
    this.loadBagouts = false;
    this.$location = $location;
    this.$rootScope.$broadcast('routeChange', '/app/bag-out');
    this.sortBy = {
      fieldName: 'id',
      sortASC: true
  }
    this.Configs = Configs;
  }

  resetModel() {
    this.model = {
      bagout: {
        trackingId: ''
      },
      bag: {
        id: ''
      }
    }
  }

  focusElementById(id) {
    setTimeout(() => {
      document.getElementById(id).focus()
    }, 500)
  }

  $onInit() {
    this.resetModel();
    // this.focusElementById('bag-id');
    const branchId = this.User.getUser().branchId;
    this.branchId = branchId;

    this.SetupService.get(branchId)
      .then((setup) => {
        this.prefixes = setup.prefixes;
        this.bagScanLimit = setup.packCharLength;
        this.loadDeliverToLocation('', 0);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
  }

  scanError() {
    this.bagScanLimitExceed = true;
    this.checkOnlyOnce = true;
    this.loading = false;
    this.isError = true;
    this.bagoutScanDisable = false;
  }

  bagoutScanned(event) {
    if (!this.model.bag.trackingId || !this.model.bagout.id) {
      return;
    }

    this.loading = true
    this.reset();

    this.lastBagoutScanned = {
      scannedDate: moment(new Date()).format('ddd ,ll'),
      scannedTime: moment(new Date()).format('LTS'),
      id: this.model.bagout.id
    };

    if (this.model.bagout.id) {
      // let finalBagOutId;
      // if (this.prefixes && this.prefixes.bagout) {
      //   if (this.model.bagout.id.toUpperCase().startsWith(this.prefixes.bagout[0])) {
      //     finalBagOutId = this.model.bagout.id.slice(this.prefixes.bagout[0].length)
      //   } else {
      //     finalBagOutId = this.model.bagout.id;
      //   }
      // } else {
      //   finalBagOutId = this.model.bagout.id;
      // }

      // if (this.bagScanLimit && this.bagScanLimit > 0) {
      //   if (finalBagOutId.length > this.bagScanLimit && (!this.checkOnlyOnce || finalBagOutId.length !== this.checkLength)) {
      //     this.lastScanned = finalBagOutId;
      //     this.checkLength = finalBagOutId.length;
      //     finalBagOutId = "";
      //     this.scanError();
      //     // this.clearBagout(event);
      //     this.clearBagId(event);
      //     this.bagScanError = this.$translate.instant('common.scan_error');
      //     return Promise.resolve();
      //   }
      //   else {
      //     this.checkLength = finalBagOutId.length > this.bagScanLimit ? finalBagOutId.length : this.bagScanLimit;
      //   }
      // }

      // this.model.bagout.id = finalBagOutId;

      return this.ShipmentService.addToBag(this.model.bag.trackingId, this.model.bag.toLocationId, this.model.bagout.id, this.lastBagScanned.branchId)
        .then((result) => {
          if (result.status === false) {
            this.loading = true
            this.isError = true
            this.message = this.$translate.instant('error.' + result.message) || null;
            this.Sound.PlayErrorBeep("#scanner_beep");
            return;
          }
          else {
            this.isError = false
            this.message = this.$translate.instant('bagout.item') + ' ' + this.model.bag.trackingId + ' ' + this.$translate.instant('bagout.added') + ' (' +
            this.$translate.instant('bagout.bagout') + ' | ' + this.model.bagout.id + ') '
            this.messageTwo = this.$translate.instant('bagout.totalItems') + ' | ' + result.currentBagCount;

            this.model.bagout.destination = {
              name: result.bagDeliveryLocationName,
              address: result.bagDeliveryLocationAddress
            };
            this.Sound.playSuccessBeep("#success_beep");
          }

          delete this.bagScanError;
          this.lastBagoutScanned = Object.assign({}, this.lastBagoutScanned, this.model.bagout);
          this.loading = false
          this.model.bag = {};
          // this.model.bagout.id = ''
          this.prevErrorCode = '';
          this.bagoutScanDisable = false;
          this.focusElementById('bag-id');
        })
        .catch((err) => {
          delete this.bagScanError;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.isError = true;

          if (err.data && err.data.message) {

            // if (this.forceToStope.indexOf(err.data.message) > -1) {
            //   this.model.bag.trackingId = undefined;
            //   this.clearBagId(event);
            // }

            this.message = this.$translate.instant('error.' + err.data.message, {
              trackingId: this.lastBagScanned.trackingId,
              bagoutId: this.model.bagout.id,
            }) || null;

            this.lastBagoutScanned = Object.assign({}, this.lastBagoutScanned, this.model.bagout);
            this.prevErrorCode = err.data.message
            // return this.clearBagout(event);

            if (err.data.message == '90704') {
              this.clearBagout(event);
              this.bagoutScanDisable = true;
              this.loading = false;
              // this.focusElementById('bag-id'); 
              // this.focusElementById('bagout-id'); 
              return this.clearBagId(event);
            }
            else {
              this.clearBagId(event);
              return this.clearBagout(event);
            }
          }
          else {
            this.message = err.toString();
          }
        });
    } else {
      this.bagoutScanDisable = false;
    }
  }

  selectDeliveryLocation(shipment) {
    const locationFields = ['deliveryLoc1Id', 'deliveryLoc2Id', 'deliveryLocCodId', 'deliveryLocCoinId'];
    const defer = this.$q.defer();
    let availableDeliveryLocations = [];

    locationFields.forEach((locationField) => {
      const locationId = shipment.toLocation[locationField];
      if (locationId && availableDeliveryLocations.indexOf(locationId) === -1) {
        availableDeliveryLocations.push(locationId)
      }
    })

    if (availableDeliveryLocations.length === 0) {
      defer.reject(new Error(`Delivery Locations are missing for location ${shipment.toLocation.name}`));
    }
    else if (availableDeliveryLocations.length === 1) {
      defer.resolve(availableDeliveryLocations[0]);
    }
    else {
      this.Modal.selectDeliveryLocation(availableDeliveryLocations, ({ $scope, modal }) => {
        defer.resolve($scope.selectedLocationId);
        modal.close();
      }, ({ modal }) => {
        modal.close();
      });
    }

    return defer.promise;
  }

  bagScanned(event) {
    if (!this.model.bag.trackingId) {
      return;
    }

    this.bagScanDisable = true;
    this.loading = false;

    if (this.model.bag.trackingId && this.prefixes && this.prefixes.deliveryAndPickups) {
      if (this.model.bag.trackingId.toUpperCase().startsWith(this.prefixes.deliveryAndPickups[0])) {
        this.model.bag.trackingId = this.model.bag.trackingId.slice(this.prefixes.deliveryAndPickups[0].length).trim();
      }
    }

    if (this.forceToStope.indexOf(this.prevErrorCode) >= 0) {
      if (this.lastBagScanned && this.lastBagScanned.trackingId !== this.model.bag.trackingId) {
        this.isError = true;
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.model.bag.trackingId = undefined;
        this.model.bag.toLocation = undefined;
        // this.model.bagout = {};
        this.bagScanDisable = false;
        this.message = this.$translate.instant('error.rescanLastItemId');
        this.messageTwo = '';
        return Promise.resolve();
      }
    }

    let bagScanObj = {
      queryJSON: {
        rules: [
          {
            field: 'trackingId',
            condition: '=',
            data: this.model.bag.trackingId
          },
          {
            field: 'branchId',
            condition: '=',
            data: this.branchId
          },
        ],
        operator: 'AND'
      }
    };

    // this.ShipmentService.get(this.model.bag.trackingId)
    return this.ShipmentService.all(bagScanObj)
      .then((shipments) => {
        const shipment = shipments.results.length > 0 ? shipments.results[0] : undefined;

        delete this.lastBagScanned;
        delete this.isError;
        delete this.message;
        delete this.messageTwo;
        delete this.bagScanError;
        this.lastBagScanned = Object.assign({}, shipment);

        if (!shipment) {
          this.lastBagScanned = { trackingId: this.model.bag.trackingId };
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.message = this.message = this.$translate.instant('bagout.bagNotFound') + ' (' +
            this.lastBagScanned.trackingId + ' | ' + this.$translate.instant('bagout.bagNotFound') + ') ';
            this.focusElementById('bag-id');
          return this.clearBagId(event);
        }

        if (shipment.branchId !== this.branchId) {
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.isError = true;
          this.message = this.$translate.instant("error." + 91321);
          this.bagoutScanDisable = true;
          this.focusElementById('bag-id');
          return this.clearBagId(event);
        }

        if (shipment.bagSeal) {
          this.isError = true
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.message = this.$translate.instant('bagout.bagAlreadyAdded') + ' (' +
          this.lastBagScanned.trackingId + ' | ' + this.$translate.instant('bagout.previouslyAdded') + ') ';
          this.focusElementById('bag-id');
          return this.clearBagId(event);
        }

        if (shipment.holdFlag) {
          this.isError = true
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.message = 
            // this.$translate.instant('bagout.shipmentOnHold') + '<br/>' +
            this.lastBagScanned.trackingId + ' | ' + this.$translate.instant('bagout.shipmentOnHold');
            this.focusElementById('bag-id');
          return this.clearBagId(event);
        }
        else if (shipment.deliveredFlag) {
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.message = 'Shipment has already been delivered (' + this.lastBagScanned.trackingId + ' | Delivered) ';
          this.focusElementById('bag-id');
          return this.clearBagId(event);
        }
        else if (!shipment.checkedIn && shipment.shiptypeId !== 'BULKCASH') {
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.message = this.$translate.instant('bagout.shipmentNotCheckedIn') + ' (' +
            this.lastBagScanned.trackingId + ' | ' + this.$translate.instant('bagout.notCheckedIn') + ') ';
            this.focusElementById('bag-id');
          return this.clearBagId(event);
        }

        if (shipment.toLocation) {
          this.model.bag.deliveryLocationId = shipment.toLocation.id;
          this.Sound.playSuccessBeep("#success_beep");
          this.bagScanDisable = false;
          this.bagoutScanDisable = false;
          // this.focusElementById('bagout-id');
          this.focusElementById('bag-id');
        } else {
          this.isError = true;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.message = this.$translate.instant('bagout.wrongDestination') || null;
          this.focusElementById('bag-id');
          return this.clearBagId(event);
        }

        // this.selectDeliveryLocation(shipment)
        // .then((selectedLocationId) => {
        //   this.model.bag.deliveryLocationId = selectedLocationId;
        //   this.focusElementById('bagout-id');
        // })
        // .catch((err) => {
        //   this.isError = true;
        //   this.message = err.message
        // })

        this.model.bag = shipment
        if (this.forceToStope.indexOf(this.prevErrorCode) >= 0) {
          if (this.lastBagScanned.trackingId == this.model.bag.trackingId) {
            this.Sound.playSuccessBeep("#success_beep");
            this.model.bag.toLocation = undefined;
            this.model.bag.trackingId = null;
            this.prevErrorCode = undefined;
            this.bagScanDisable = false;
            this.bagoutScanDisable = true;
            this.focusElementById('bag-id');
          }
        }
      })
      .catch((err) => {
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.lastBagScanned = { trackingId: this.model.bag.trackingId };
        this.isError = true;
        this.message = this.$translate.instant("error." + err.data.message)
        // this.model.bag = {};
        this.bagoutScanDisable = true;
        this.clearBagId(event);
      })
  }

  closePrint() {
    // if (this.isLoading) true;
    // this.isLoading = true;
    // this.Modal.closeBagout('', ({ modal }) => {
    //   this.isLoading = false;
    //   if (modal) modal.close();
    // }, ({ modal }) => {
    //   this.isLoading = false;
    //   if (modal) modal.close();
    // });
    if (this.model.bagout.id === "" || this.model.bagout.id == undefined) {
      return;
    }

    let finalBagOutId;
    if (this.prefixes && this.prefixes.bagout) {
      if (this.model.bagout.id.toUpperCase().startsWith(this.prefixes.bagout[0])) {
        finalBagOutId = this.model.bagout.id.slice(this.prefixes.bagout[0].length);
      } else {
        finalBagOutId = this.model.bagout.id;
      }
    } else {
      finalBagOutId = this.model.bagout.id;
    }
    
    return this.BagoutService.getShipments(finalBagOutId)
      .then(() => {
        this.loading = false;
        this.$location.url('/app/bag-out-print?bagout=' + finalBagOutId);
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      });
  }

  clearBagId(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      this.model.bag = {};
      this.model.bag.toLocation = undefined;
      this.bagScanDisable = false;
      // this.focusElementById('bag-id');
    };
  }
  clearBagout(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      // this.BagoutInfo = []
      this.model.bagout = {};
      this.bagoutScanDisable = false;
      this.focusElementById('bagout-id');
    }
  }

  locationSearchObj(searchKey) {
    searchKey = searchKey || '';

    const searchObj = {
      queryJSON: {
        rules: [{
          field: 'branchId',
          condition: '=',
          data: this.branchId
        },
        {
          field: 'active',
          condition: '=',
          data: true
        },
        {
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + searchKey + '%'
            },
            {
              field: 'name',
              condition: 'like',
              data: '%' + searchKey + '%'
            }
            ],
            operator: 'OR'
          }
        },
        {
          group: {
            rules: [
              {
                group: {
                  rules: [
                    {
                    field: 'locationType',
                    condition: "IN",
                    data: ["DELIVERY","BANK"] 
                  },
                  {
                    field: "bagoutEnabled", 
                    condition: "=",
                    data: true
                  }
                  ],
                  "operator": "AND"
                }
              }
            ],
            "operator": "OR"
          }
        }],
        operator: 'AND'
      },
      order: {
        fieldName: this.sortBy.fieldName,
        sortASC: this.sortBy.sortASC
      }
    };
    return searchObj.queryJSON.rules.length ? searchObj : null;
  }

  loadDeliverToLocation(searchKey, offset) {
    var locationSearchObj = this.locationSearchObj(searchKey);
    this.LocationService.all(locationSearchObj, offset, AppConstant.defaultPageLimit)
      .then((res) => {
        if (offset === 0) {
          this.totalLocations = res.total;
          this.locationList = this.locationMapping(res.results);
        } else {
          const locations = this.locationMapping(res.results);
          this.locationList = this.locationList.concat(locations);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  }

  locationMapping(data) {
    return data.map((loc) => {
      return {
        Key: loc.id + ' | ' + loc.name,
        Value: loc.id
      }
    });
  }

  getRemainingBagoutCount(focusTargetId = 'bag-id') {

    if (!this.model.toLocation) {
      return this.remainingBagoutInfo = '';
    };

    this.loadRemainingBagouts = true;
    return this.BagoutService.getRemainingBagoutCount(this.branchId, this.model.toLocation.Value)
      .then((res) => {
        this.remainingBagoutInfo = res;
        this.focusElementById(focusTargetId);
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.loadRemainingBagouts = false;
      })
  }

  getTotalItemsInBagoutCount() {

    if (!this.model.bagout.id) return;

    this.loadBagouts = true;
    return this.BagoutService.getTotalItemsInBagoutCount(this.model.bagout.id)
      .then((res) => {
        this.BagoutInfo = res;
        this.focusElementById('bag-id');
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.loadBagouts = false;
      })
  }

  getBagoutList(infoFor) {
    if (infoFor === 'remainingBagout') {
      if (!this.model.toLocation) return;
    }
    else if (infoFor === 'includedBagout') {
      if (!this.model.bagout.id && !this.lastScanned) return;
    }
    
    let bagSealId = this.model.bagout.id ? this.model.bagout.id : this.lastScanned;
    this.Modal.bagoutListModal(this.branchId, this.model.toLocation ? this.model.toLocation : null, bagSealId, infoFor, ({ $scope, modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    });
  }

  loadOrAddBagouts(event) {

    if(!this.model.bagout.id) return;

    this.bagScanLimitExceed = false;
    this.reset();
    // this.lastScannedBagoutId();

    let finalBagOutId;
    if (this.prefixes && this.prefixes.bagout) {
      if (this.model.bagout.id.toUpperCase().startsWith(this.prefixes.bagout[0])) {
        finalBagOutId = this.model.bagout.id.slice(this.prefixes.bagout[0].length);
        this.lastScanned = finalBagOutId;
        this.model.bagout.id = this.lastScanned;
        this.lastScannedBagoutId();
      } else {
        finalBagOutId = this.model.bagout.id;
        this.lastScanned = finalBagOutId;
        this.model.bagout.id = this.lastScanned;
        this.lastScannedBagoutId();
      }
    } else {
      finalBagOutId = this.model.bagout.id;
      this.lastScanned = finalBagOutId;
      this.model.bagout.id = this.lastScanned;
      this.lastScannedBagoutId();
    }

    // if (this.bagScanLimit && this.bagScanLimit > 0) {
    //   if (finalBagOutId.length > this.bagScanLimit && (!this.checkOnlyOnce || finalBagOutId.length !== this.checkLength)) {
    //     this.lastScanned = finalBagOutId;
    //     this.checkLength = finalBagOutId.length;
    //     finalBagOutId = "";
    //     this.scanError();
    //     this.clearBagout(event);
    //     this.clearBagId(event);
    //     this.bagScanError = this.$translate.instant('common.scan_error');
    //     this.model.bagout.id = finalBagOutId;
    //     this.lastScannedBagoutId();
    //     return Promise.resolve();
    //   }
    //   else {
    //     this.checkLength = finalBagOutId.length > this.bagScanLimit ? finalBagOutId.length : this.bagScanLimit;
    //     this.model.bagout.id = finalBagOutId;
    //     this.lastScannedBagoutId();
    //     delete this.isError;
    //     delete this.bagScanError;
    //   }
    // }

    if (this.bagScanLimit && this.bagScanLimit > 0) {
      const envConfig = this.Configs.getEnvironmentConfig();
      const bagOutLimit = (envConfig && envConfig.bagoutManifestConfig && envConfig.bagoutManifestConfig.bagOutScanLimit) || AppConstant.defaultBagOutScanLimit;
      console.log(bagOutLimit)

      if (finalBagOutId.length > bagOutLimit) {
        this.lastScanned = finalBagOutId;
        // this.checkLength = finalBagOutId.length;
        finalBagOutId = "";
        this.scanError();
        this.clearBagout(event);
        this.clearBagId(event);
        this.bagScanError = this.$translate.instant('bagout.scan_error', {
          maxLength: bagOutLimit
        });
          // $scope.model.errorMsg = $translate.instant('branch_mgmt.items.duplicate_destination_error', {
          //     trackingId: $scope.model.shipmentData.trackingId,
          //     locationId: $scope.model.location.Value
          //   })
        this.model.bagout.id = finalBagOutId;
        this.lastScannedBagoutId();
        return Promise.resolve();
      }
      else {
        // this.checkLength = finalBagOutId.length > this.bagScanLimit ? finalBagOutId.length : this.bagScanLimit;
        this.model.bagout.id = finalBagOutId;
        this.lastScannedBagoutId();
        delete this.isError;
        delete this.bagScanError;
      }
    }

    this.getTotalItemsInBagoutCount()
      .then(() => {
        // this.loading = false;
        this.bagoutScanDisable = false;
        this.focusElementById('bag-id');
      });
  }

  addBagout(event) {

    if (!this.model.bag.trackingId) return;

    this.bagScanned(event).then(() => {
      if (!this.isError && this.model.bag.trackingId) {
        return this.bagoutScanned(event).then(() => {
          if (!this.isError) {
            this.getRemainingBagoutCount();
            this.getTotalItemsInBagoutCount();
          }
        })
      }
    })
  }

  lastScannedBagoutId() {
    this.lastBagoutScanned = {
      scannedDate: moment(new Date()).format('ddd ,ll'),
      scannedTime: moment(new Date()).format('LTS'),
      id: this.lastScanned
    };
  }

  reset() {
    this.bagScanLimitExceed = false;
    this.bagoutScanDisable = true;
    delete this.lastBagoutScanned;
    delete this.isError;
    delete this.message;
    delete this.messageTwo;
  }

  resetData() {
    this.reset();
    this.model.bag = {};
    this.model.bagout = {};
    this.lastBagScanned = null;
    this.remainingBagoutInfo = '';
    this.BagoutInfo = '';
    this.bagoutScanDisable = false;
    this.prevErrorCode = undefined;
    this.lastScanned = null;
  }

}

export default BagoutController;



// WEBPACK FOOTER //
// ./client/app/components/bagout/bagout.controller.js